/**
 * Navigation service that can be used outside of React components
 * This allows navigation from places like Axios interceptors
 */

let navigate: ((path: string) => void) | null = null;

export const NavigationService = {
  /**
   * Set the navigation function from a React component that has access to useNavigate()
   */
  setNavigate: (navigateFunction: (path: string) => void) => {
    navigate = navigateFunction;
  },

  /**
   * Navigate to a specific path
   */
  navigate: (path: string) => {
    if (navigate) {
      navigate(path);
    } else {
      // Fallback to window.location if navigate is not set
      console.warn("NavigationService: navigate function not set, falling back to window.location");
      window.location.href = path;
    }
  },

  /**
   * Navigate to login page
   */
  navigateToLogin: () => {
    NavigationService.navigate("/login");
  },
};
